import { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { PageLoading } from "./components/Loading";
import ErrorMessage, { PageErrorContainer } from "./components/Error";
import { SecondaryButton } from "./components/buttons/SecondaryButton";
import { useClerk } from "@clerk/clerk-react";
import { useDispatch } from "react-redux";
import { SPACING } from "./components/theme";

const ButtonRow = styled.div`
  display: flex;
  gap: ${SPACING.SM_MD};
  margin-top: ${SPACING.MD};
`;

const LoadToError = ({ isFetching = false }: { isFetching?: boolean }) => {
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();
  const { signOut } = useClerk();

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 5000);
  }, [isFetching]);

  if (isLoading || isFetching) {
    return <PageLoading />;
  }

  return (
    <PageErrorContainer>
      <ErrorMessage>
        It looks like there was an error loading the page. Please sign out and
        try again or contact support.
      </ErrorMessage>
      <ButtonRow>
        <SecondaryButton
          css={{ width: "fit-content" }}
          onClick={async () => {
            dispatch({ type: "USER_LOGOUT" });
            await signOut({ redirectUrl: "/login" });
          }}
        >
          Log out
        </SecondaryButton>
      </ButtonRow>
    </PageErrorContainer>
  );
};

export default LoadToError;
